/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Overwrite_Selected_TitleInputs */

const en_explorer_display_overwrite_selected_title = /** @type {(inputs: Explorer_Display_Overwrite_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite Selected Project`)
};

const fr_explorer_display_overwrite_selected_title = /** @type {(inputs: Explorer_Display_Overwrite_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ecraser le projet selectionne`)
};

const de_explorer_display_overwrite_selected_title = /** @type {(inputs: Explorer_Display_Overwrite_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewähltes Projekt überschreiben`)
};

const it_explorer_display_overwrite_selected_title = /** @type {(inputs: Explorer_Display_Overwrite_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovrascrivi il progetto selezionato`)
};

const ru_explorer_display_overwrite_selected_title = /** @type {(inputs: Explorer_Display_Overwrite_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перезаписать выбранный проект`)
};

const es_explorer_display_overwrite_selected_title = /** @type {(inputs: Explorer_Display_Overwrite_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobrescribir el proyecto seleccionado`)
};

const zh_cn2_explorer_display_overwrite_selected_title = /** @type {(inputs: Explorer_Display_Overwrite_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`覆盖选定项目`)
};

const ja_explorer_display_overwrite_selected_title = /** @type {(inputs: Explorer_Display_Overwrite_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したプロジェクトを上書き`)
};

const hi_explorer_display_overwrite_selected_title = /** @type {(inputs: Explorer_Display_Overwrite_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित प्रोजेक्ट को ओवरराइट करें`)
};

const pt_pt2_explorer_display_overwrite_selected_title = /** @type {(inputs: Explorer_Display_Overwrite_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobrescrever projeto selecionado`)
};

/**
* | output |
* | --- |
* | "Overwrite Selected Project" |
*
* @param {Explorer_Display_Overwrite_Selected_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_overwrite_selected_title = /** @type {((inputs?: Explorer_Display_Overwrite_Selected_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Overwrite_Selected_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_overwrite_selected_title(inputs)
	if (locale === "de") return de_explorer_display_overwrite_selected_title(inputs)
	if (locale === "it") return it_explorer_display_overwrite_selected_title(inputs)
	if (locale === "ru") return ru_explorer_display_overwrite_selected_title(inputs)
	if (locale === "es") return es_explorer_display_overwrite_selected_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_overwrite_selected_title(inputs)
	if (locale === "ja") return ja_explorer_display_overwrite_selected_title(inputs)
	if (locale === "hi") return hi_explorer_display_overwrite_selected_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_overwrite_selected_title(inputs)
	return en_explorer_display_overwrite_selected_title(inputs)
});